import { render, staticRenderFns } from "./I2FormMultipleSelect.vue?vue&type=template&id=3b062e51&"
import script from "./I2FormMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./I2FormMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./I2FormMultipleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports